//
// Copyright (c) 2011-2024 by Curalate, Inc.
//

import { IGetUsersResponse } from '@apis/users/usersApiModel';
import { serializedSessionFetch } from '@utils/sessionFetch';

/**
 * GET /api/users
 * Fetch all users
 * @param init Request
 * @returns List of users
 */
export const getUsers = async (
  init?: RequestInit,
): Promise<IGetUsersResponse> => {
  const res = await serializedSessionFetch('/api/users', {
    ...(init ? init : {}),
  });
  return res.json();
};
